import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const permissionService = {
  listPermissions: async (params = {}) => (await api.get('/permissions', { params })).data,
  listModules: async () => (await api.get('/permissions/modules/list')).data,
  seedTaskPermissions: async () => (await api.post('/permissions/seed/tasks')).data,
};

export default permissionService;










